import { PublicResource, Related } from '../../resource-types';
import { RawModel } from '../schema';

export type ContractStatuses =
  | 'CONTRACT_STATUS_DRAFT'
  | 'CONTRACT_STATUS_FINAL';

export interface Contract extends PublicResource {
  starts_at?: string;
  expires_at?: string;
  expires?: boolean;
  expires_soon?: boolean;
  extended: boolean;
  notification_recipients: string[];
  status: ContractStatuses;
  remind_at?: string;
  relationships: {
    contract_type?: Related<'contract'>;
    assets?: Related<'asset'>[];
    projects?: Related<'project'>[];
  };
}

export const contract: RawModel = {
  type: 'contract',
  plural: 'contracts',
  JSONApi: true,
  useWorker: true,
  attributes: {
    id: 'UUID',
    display_name: 'string',
    expires_at: 'date',
    starts_at: 'date'
  },
  relationships: {
    contract_type: {
      type: 'contract-type',
      binding: ['one', 'many'],
      required: true
    },
    projects: {
      type: 'project',
      binding: ['many', 'many'],
      reverse: 'contracts',
      required: false
    },
    assets: {
      type: 'asset',
      binding: ['many', 'many'],
      reverse: 'contracts',
      required: false
    }
  }
};
